import { ReactNode } from "react";
import { Flex, Col, Typography } from "antd";
import { v4 as uuidv4 } from "uuid";

import { ItemInfo } from "./ItemInfo";
import { ItemInfoType } from "interfaces";

import styles from "./info.module.css";
import { WrappedItemInfo } from "./WrappedItemInfo";

interface IProps {
  items: ItemInfoType[];
  oneColumn?: boolean;
  blockTitle?: string | ReactNode;
  vertical?: boolean;
  withBackground?: boolean;
  id?: string;
}

export const ItemInfoBlock = (props: IProps) => {
  const { items, oneColumn, blockTitle, vertical = true, id, withBackground = false } = props;
  return (
    <Flex className={styles.infoBlock} vertical gap="12px" id={id}>
      {typeof blockTitle === "string" ? (
        <Typography.Text strong className="whitebox-title">
          {blockTitle}
        </Typography.Text>
      ) : (
        blockTitle
      )}
      <Flex wrap>
        {items
          .filter((item) => !!item)
          .map((item) =>
            withBackground ? (
              <Col span={item?.width ?? (oneColumn ? 24 : 12)} className="margin-bottom-sm" key={uuidv4()}>
                <WrappedItemInfo title={item?.label} text={item?.text} id={item?.id} />
              </Col>
            ) : (
              <Col span={item?.width ?? (oneColumn ? 24 : 12)} key={uuidv4()}>
                <ItemInfo title={item?.label} text={item?.text} vertical={vertical} id={item?.id} />
              </Col>
            )
          )}
      </Flex>
    </Flex>
  );
};
